(() => {
  function setup(root) {
    root.querySelectorAll('[data-ec-zoom-button]').forEach(button => {
      if (button.dataset.ecReady) return;
      button.dataset.ecReady = 'true';
      button.hidden = false;
      button.addEventListener('click', () => {
        const active = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', active ? 'Zoom out to the gym equipment illustration' : 'Zoom into the illustrated microbes');
        button.closest('[data-ec-zoom]').classList.toggle('is-zoomed', active);
        button.replaceChildren(document.createTextNode(active ? 'Zoom out ' : 'Zoom in '));
        const icon = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = active ? '−' : '+';
        button.append(icon);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document), {once:true});
  else setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
